import {RemoteI9Status} from '@dtos/remote-i9-status';
import {getRemoteI9FlowFromRemoteI9Type, RemoteI9Flow} from '@models/remote-i9-flow';
import Routes from '@models/routes';
import {IRemoteRepresentativeService} from '@services/remote-representative-service';
import {IConfigurationValuesService} from '@services/ConfigurationValuesService';

export interface ISectionFlowRoutingService {
    /**
     * Consults the latest Remote I-9 status before providing
     * the route to trigger the corresponding Section
     * @throws When the status could not be fetched
     * or when the status has no corresponding section
     */
    routeSectionFromStatusAsync(): Promise<Routes>;
}

export enum SectionFlowRoutingErrors {
    UnrecognisedI9FlowType = 'Unrecognised I9 flow type',
    UnrecognisedSection2Status = 'Unrecognised status for Section 2'
}

export class SectionFlowRoutingService implements ISectionFlowRoutingService {
    constructor(
        private remoteRepresentativeService: IRemoteRepresentativeService,
        private configurationValuesService: IConfigurationValuesService
    ) {
    }

    routeSection3Flow(): Routes {
        return Routes.Section3Review;
    }

    routeSection2Flow(status: RemoteI9Status, documentsRequired: boolean): Routes {
        const enabledUploadDocuments = this.configurationValuesService?.enabledUploadDocuments;
        if (enabledUploadDocuments && documentsRequired) {
            return Routes.Section2UploadDocuments;
        }

        switch (status) {
            case RemoteI9Status.REPRESENTATIVE_PENDING:
                return Routes.Section2Documents;
            case RemoteI9Status.REPRESENTATIVE_DOCUMENTS_APPROVED:
                return Routes.Section2EmployeeInformation;
            default:
                throw new Error(SectionFlowRoutingErrors.UnrecognisedSection2Status);
        }
    }

    async routeSectionFromStatusAsync(): Promise<Routes> {
        const {
            documentsRequired,
            status,
            type
        } = await this.remoteRepresentativeService.getStatusAsync();

        switch (getRemoteI9FlowFromRemoteI9Type(type)) {
            case RemoteI9Flow.Section2:
                return this.routeSection2Flow(status, documentsRequired);
            case RemoteI9Flow.Section3:
                return this.routeSection3Flow();
            default:
                throw new Error(SectionFlowRoutingErrors.UnrecognisedI9FlowType);
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/section-flow-routing-service.ts